import React from 'react';
import axios from 'axios';

const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS  = 120000;

const csrfToken = () =>
  document.querySelector("meta[name='csrf-token']").content;

class SyncButton extends React.Component {
  state = {
    syncing: false,
    message: null,
    error:   false,
  };

  handleSync() {
    this.setState({ syncing: true, message: 'Connecting…', error: false });
    axios.get('/billing/sync_status').then(({ data }) => {
      const baseline  = data.last_updated_at;
      const startedAt = Date.now();
      axios
        .post('/billing/sync', {}, {
          headers: { 'X-CSRF-Token': csrfToken(), Accept: 'application/json' },
        })
        .then(() => {
          this.setState({ message: 'Syncing invoices…' });
          this.poll(baseline, startedAt);
        })
        .catch(() => {
          this.setState({ syncing: false, message: 'Sync failed. Please try again.', error: true });
        });
    }).catch(() => {
      this.setState({ syncing: false, message: 'Sync failed. Please try again.', error: true });
    });
  }

  poll(baseline, startedAt) {
    if (Date.now() - startedAt > POLL_TIMEOUT_MS) {
      this.setState({
        syncing: false,
        message: 'Sync is taking longer than expected — refresh to see updates.',
      });
      return;
    }

    setTimeout(() => {
      axios.get('/billing/sync_status').then(({ data }) => {
        if (data.last_updated_at !== baseline) {
          this.setState({ message: 'Invoices updated! Reloading…' });
          setTimeout(() => window.location.reload(), 1000);
        } else {
          this.poll(baseline, startedAt);
        }
      }).catch(() => this.poll(baseline, startedAt));
    }, POLL_INTERVAL_MS);
  }

  render() {
    const { syncing, message, error } = this.state;

    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
                    gap: '12px', padding: '0 0 12px 0' }}>
        {message && (
          <span style={{ fontSize: '14px', color: error ? 'red' : '#555' }}>
            {message}
          </span>
        )}
        <button
          className="btn btn-indigo btn-raised"
          onClick={() => this.handleSync()}
          disabled={syncing}
        >
          {syncing ? 'Syncing…' : 'Sync Invoices'}
        </button>
      </div>
    );
  }
}

export default SyncButton;